/**
 * Общий навигационный набор для desktop Sidebar и mobile drawer.
 * Один источник правды - один и тот же список рендерится в обоих местах
 */
import {
  Activity, CreditCard, Files, History, MessageSquarePlus, Settings, Sparkles,
} from "lucide-react";

export const NAV_KEYS = {
  newChat: "nav.newChat",
  history: "nav.history",
  models: "nav.models",
  files: "nav.files",
  monitoring: "nav.monitoring",
  billing: "nav.billing",
  settings: "nav.settings",
} as const;

export interface NavItem {
  to: string;
  i18nKey: keyof typeof NAV_KEYS;
  icon: React.ComponentType<{ className?: string }>;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/chat/new",   i18nKey: "newChat",    icon: MessageSquarePlus },
  { to: "/chats",      i18nKey: "history",    icon: History },
  { to: "/catalog",     i18nKey: "models",     icon: Sparkles },
  { to: "/files",      i18nKey: "files",      icon: Files },
  { to: "/monitoring", i18nKey: "monitoring", icon: Activity },
  { to: "/billing",    i18nKey: "billing",    icon: CreditCard },
  { to: "/settings",   i18nKey: "settings",   icon: Settings },
];
